import { HelmetDexteel } from "@dexteel/mesf-core";
import { TableInspectionTemplates } from "./components/TableInspectionTemplates";

export const InspectionTemplatesPage = () => {
	return (
		<>
			<HelmetDexteel title="Inspection Templates" />
			<TableInspectionTemplates />
		</>
	);
};
